export const FETCH_PATHWAYS_COMPLETED_START = 'FETCH_PATHWAYS_COMPLETED_START';
export const FETCH_PATHWAYS_COMPLETED_FAIL = 'FETCH_PATHWAYS_COMPLETED_FAIL';
export const FETCH_PATHWAYS_COMPLETED_SUCCESS = 'FETCH_PATHWAYS_COMPLETED_SUCCESS';

export const FETCH_PATHWAY_START = 'FETCH_PATHWAY_START';
export const FETCH_PATHWAY_FAIL = 'FETCH_PATHWAY_FAIL';
export const FETCH_PATHWAY_SUCCESS = 'FETCH_PATHWAY_SUCCESS';
